<div class="flex flex-col gap-1 justify-center items-center">
    <ng-lottie [width]="width" [height]="height" [options]="options"></ng-lottie>
    <h2 [style.color]="color" [class]="fontsize" class="text-center">{{message}}</h2>
</div>